import React, { useEffect, useMemo, useState } from 'react';
import GpayScratchFoil, {
  isCouponScratched,
  markCouponScratched,
} from './GpayScratchFoil';
import './ScratchCard.css';

const ScratchCard = ({
  children,
  onComplete,
  onClose,
  couponId,
  isOpen = false,
  onClaim,
  onUtilizeLater,
  discountLabel,
  rewardTitle,
  rewardSubtitle,
  couponCode,
  businessName,
  alreadyScratched = false,
}) => {
  const already = useMemo(
    () => Boolean(alreadyScratched || (couponId && isCouponScratched(couponId))),
    [couponId, isOpen, alreadyScratched]
  );
  const [revealed, setRevealed] = useState(already);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setRevealed(already);
    } else {
      document.body.style.overflow = '';
    }

    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) onClose?.();
    };
    window.addEventListener('keydown', handleEscape);
    return () => {
      window.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose, already]);

  if (!isOpen) return null;

  const label = discountLabel || 'REWARD';

  return (
    <div className="scratch-card-modal-overlay" onClick={onClose}>
      <div className="scratch-card-modal gpay-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="scratch-card-close" onClick={onClose} aria-label="Close">
          <i className="fas fa-times" />
        </button>

        <div className="scratch-card-container gpay-sheet">
          <div className="gpay-sheet-header">
            <div className="gpay-sheet-icon">
              <i className="fas fa-gift" />
            </div>
            <div>
              <h2>{revealed ? 'Congratulations!' : 'Scratch to unlock'}</h2>
              <p>
                {revealed
                  ? 'Your reward is ready to use'
                  : 'Scratch the silver foil — like Google Pay rewards'}
              </p>
            </div>
          </div>

          <GpayScratchFoil
            couponId={couponId}
            alreadyRevealed={already}
            discountLabel={label}
            height={240}
            onRevealed={() => {
              setRevealed(true);
              markCouponScratched(couponId);
              onComplete?.();
            }}
          >
            {children || (
              <>
                <div className="gpay-reward-meta">
                  <span className="gpay-reward-badge">YOU WON</span>
                  {businessName ? (
                    <span className="gpay-reward-shop">{businessName}</span>
                  ) : null}
                </div>
                <div className="gpay-reward-discount">{label}</div>
                <p className="gpay-reward-title">
                  {rewardTitle || 'Your Locsy coupon'}
                </p>
                {rewardSubtitle ? (
                  <p className="gpay-reward-sub">{rewardSubtitle}</p>
                ) : null}
                {revealed && couponCode ? (
                  <div className="gpay-reward-code">{couponCode}</div>
                ) : null}
              </>
            )}
          </GpayScratchFoil>

          {revealed ? (
            <div className="scratch-card-actions gpay-actions">
              {onClaim ? (
                <button type="button" className="btn-claim" onClick={onClaim}>
                  <i className="fas fa-check-circle" />
                  Claim & Create Bill
                </button>
              ) : null}
              <button
                type="button"
                className="btn-utilize-later"
                onClick={onUtilizeLater || onClose}
              >
                <i className="fas fa-clock" />
                {onUtilizeLater ? 'Utilize Later' : 'Awesome'}
              </button>
            </div>
          ) : (
            <p className="gpay-scratch-hint">
              Tip: keep scratching until the foil peels away
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScratchCard;
